import OptimoveOverview from './OptimoveOverview'
import OptimoveSettings from './OptimoveSettings'
import OptimoveTasks from './OptimoveTasks'
import OptimoveSyncAttrsDialog from './OptimoveSyncAttrsDialog'

export default Object.freeze({
  type: 'optimove',
  title: 'Integrations_Optimove',
  category: 'Integrations_Optimove_Category',
  description: 'Integrations_Optimove_Description',
  image: require('@/img/integrations/optimove.png'),
  requiresAdmin: false,
  components: {
    overview: OptimoveOverview,
    settings: OptimoveSettings,
    tasks: OptimoveTasks
  },
  urls: {
    guide: 'https://docs.xtremepush.com/docs/optimove'
  },
  actions: [
    {
      icon: 'el-icon-refresh',
      label: 'Integrations_Optimove_Action_SyncAttrs',
      dialog: OptimoveSyncAttrsDialog,
      disabled_path: 'params.sync_attributes'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/modules/integrations/types/optimove/index.js